'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useState, useCallback, useEffect } from 'react';
import { useStripe, Elements, ExpressCheckoutElement, useElements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { formatStripeAmount } from '@/app/_lib/services/ClientUtil';
import stripePaymentIntentAction from '@/app/_lib/actions/StripePaymentIntentAction';
import stripeShippingAddressChangeAction from '@/app/_lib/actions/StripeShippingAddressChangeAction';

//import { createStripePaymentIntent, stripeShippingAddressChange } from '@/app/_lib/services/StripeCheckoutService'

// The wallet sheet handles its own failures (polite message or silent
// timeout), so nothing here ever reaches the window error reporters. These
// beacons are the only record of who opened the sheet and what happened.
const trackWallet = (event, data = {}) => {
  try {
    navigator.sendBeacon('/api/track', JSON.stringify({
      event,
      data: {
        page: window.location.pathname,
        ...data
      }
    }));
  } catch {
    // never let telemetry break checkout
  }
};
const StripeExpressCheckoutElement = ({
  expressCheckoutData,
  displayExpressPaymentIcons = false,
  displayStandardPaymentIcons = false
}) => {
  //console.log('StripeExpressCheckoutElement expressCheckoutData', expressCheckoutData)
  //console.log('StripeExpressCheckoutElement setOrderInfo', setOrderInfo)

  const elements = useElements();
  const stripe = useStripe();
  const [isVisible, setIsVisible] = useState(true);
  const [stripeOrderTotals, setStripeOrderTotals] = useState({});
  const [visiblePaymentMethods, setVisiblePaymentMethods] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const expressCheckoutOptions = {
    buttonType: {
      applePay: 'plain'
    },
    buttonHeight: 48,
    buttonTheme: {
      applePay: 'white-outline',
      googlePay: 'black'
    },
    paymentMethods: {
      applePay: 'always',
      googlePay: 'always'
    },
    layout: {
      maxColumns: 1,
      overflow: 'never'
    }
  };
  const onReady = useCallback(({
    availablePaymentMethods
  }) => {
    setVisiblePaymentMethods(availablePaymentMethods);
    //console.log('onReady availablePaymentMethods', availablePaymentMethods)
    if (!expressCheckoutData.orderTotal) {
      setIsVisible(false);
    }
    if (!availablePaymentMethods) {
      setIsVisible(false);
    } else {
      if (availablePaymentMethods.applePay == false && availablePaymentMethods.googlePay == false) {
        setIsVisible(false);
      }
    }
  }, [expressCheckoutData]);
  const onClick = async event => {
    //$parent.handleStripeClick()
    //console.log('StripeExpressCheckoutElement', 'onClick', event)
    //console.log('StripeExpressCheckoutElement', 'onClick', 'expressCheckoutData', expressCheckoutData)

    trackWallet('WALLET:CLICK', {
      wallet: event.expressPaymentType,
      order_total: expressCheckoutData.orderTotal
    });
    let lineItems = [];
    lineItems.push({
      name: 'Your Items',
      amount: formatStripeAmount(expressCheckoutData.subTotal)
    });
    if (expressCheckoutData.discount > 0) {
      lineItems.push({
        name: 'Discount',
        amount: formatStripeAmount(expressCheckoutData.discount * -1)
      });
    }
    if (expressCheckoutData.shippingCost > 0) {
      lineItems.push({
        name: 'Shipping Charges',
        amount: formatStripeAmount(expressCheckoutData.shippingCost)
      });
    }
    if (expressCheckoutData.tax > 0) {
      lineItems.push({
        name: 'Tax',
        amount: formatStripeAmount(expressCheckoutData.tax)
      });
    }
    let options = {
      emailRequired: true,
      phoneNumberRequired: true,
      business: {
        name: 'hive'
      },
      lineItems: lineItems
    };
    if (expressCheckoutData.collectShippingAddress == true) {
      options.shippingAddressRequired = true;
      options.allowedShippingCountries = ['US'];
      options.shippingRates = [{
        id: 'shipping_costs',
        displayName: 'Shipping',
        amount: formatStripeAmount(expressCheckoutData.shippingCost)
      }];
    }
    //console.log('StripeExpressCheckoutElement', 'onClick', 'options', options)
    event.resolve(options);
  };
  const handleError = error => {
    trackWallet('WALLET:SUBMIT_FAILED', {
      message: error?.message,
      code: error?.code
    });
    //const messageContainer = document.querySelector('#error-message')
    //messageContainer.textContent = error.message
  };

  // apparently this only gets called if we are collecting the shipping address from googlePay/applePay
  // 
  const onShippingAddressChange = async ({
    resolve,
    address
  }) => {
    //console.log('onShippingAddressChange', address)

    // this is your chance to calculate tax
    let shippingAddress = address;

    // NOTE shipping from stripe looks like this {city: "Indianapolis", state: "IN", postal_code: "46240", country: "US"}
    let response = await stripeShippingAddressChangeAction(shippingAddress);

    //console.log('onShippingAddressChange stripeShippingAddressChange response', response);

    if (response.success == true) {
      let orderTotals = response.data;
      setStripeOrderTotals(orderTotals);

      // NOTE the below is for the cart display - convert cents to dollars
      let cartTotals = {
        sales_tax_state: orderTotals.sales_tax_state,
        tax_percentage_value: orderTotals.tax_percentage_value,
        tax: orderTotals.tax / 100,
        // Convert cents to dollars for display
        orderTotal: orderTotals.total / 100 // Convert cents to dollars for display
      };

      //setOrderInfo(orderTotals)

      // NOTE they changed their shipping address so you have to update their cart and where their
      // order is shipped to

      // update the stripe element - orderTotals values are already in CENTS
      elements.update({
        amount: orderTotals.total
      });
      var lineItems_0 = [];
      lineItems_0.push({
        name: 'Your Items',
        amount: orderTotals.sub_total // Already in cents
      });
      if (orderTotals.discount > 0) {
        lineItems_0.push({
          name: 'Discount',
          amount: orderTotals.discount * -1 // Already in cents
        });
      }
      if (orderTotals.shipping_costs > 0) {
        lineItems_0.push({
          name: 'Shipping Charges',
          amount: orderTotals.shipping_costs // Already in cents
        });
      }
      if (orderTotals.tax > 0) {
        lineItems_0.push({
          name: 'Tax',
          amount: orderTotals.tax // Already in cents
        });
      }
      resolve({
        lineItems: lineItems_0
      });
    } else {
      // No resolve() here means Stripe shows its generic failure and the
      // customer is dead-ended - record it, this was invisible before
      trackWallet('WALLET:SHIPPING_CHANGE_FAILED', {
        state: shippingAddress?.state,
        zip: shippingAddress?.postal_code,
        response_success: response?.success
      });
    }
  };
  const onCancel = async data => {
    // handleStripeCancel()
    // refetch the cart I suppose

    // data = {elementType: 'expressCheckout'}

    trackWallet('WALLET:CANCEL', {
      order_total: expressCheckoutData.orderTotal
    });
  };
  const onConfirm = async event_0 => {
    trackWallet('WALLET:CONFIRM', {
      wallet: event_0.expressPaymentType,
      order_total: expressCheckoutData.orderTotal
    });
    const {
      error: submitError
    } = await elements.submit();
    if (submitError) {
      handleError(submitError);
      return;
    }

    //console.log('ExpressCheckoutElement', 'onConfirm', event)
    //console.log('ExpressCheckoutElement', 'expressCheckoutData', expressCheckoutData)
    //console.log('ExpressCheckoutElement', 'stripeOrderTotals', stripeOrderTotals)

    //$parent.handleStripeProcessing()

    let orderData = {};
    orderData.billingDetails = event_0.billingDetails;
    orderData.expressPaymentType = event_0.expressPaymentType;
    orderData.shippingAddress = event_0.shippingAddress;
    orderData.shippingRate = event_0.shippingRate;
    orderData.expressPaymentType = event_0.expressPaymentType;

    // Fallback: if orderTotals wasn't set by shippingaddresschange event,
    // use expressCheckoutData (which is in dollars) and convert to cents
    // This matches the Vue implementation behavior
    let orderTotalsToSend = stripeOrderTotals;
    if (!stripeOrderTotals.total) {
      orderTotalsToSend = {
        sub_total: formatStripeAmount(expressCheckoutData.subTotal),
        shipping_costs: formatStripeAmount(expressCheckoutData.shippingCost),
        discount: formatStripeAmount(expressCheckoutData.discount || 0),
        tax: formatStripeAmount(expressCheckoutData.tax || 0),
        total: formatStripeAmount(expressCheckoutData.orderTotal)
      };
    }
    orderData.orderTotals = orderTotalsToSend; // Values are in CENTS: {"sub_total":42764,"discount":0,"shipping_costs":0,"tax":0,"total":42764}

    if (expressCheckoutData.invoice_code) {
      orderData.invoice_code = expressCheckoutData.invoice_code;
    } else if (expressCheckoutData.guest_checkout == true) {
      // Normalize guest data to top level - service shouldn't care about source
      const guest = expressCheckoutData.guest;
      orderData.guest_checkout = true;
      orderData.email = guest.email;
      orderData.shipping_company_name = guest.shipping_company_name;
      orderData.shipping_first_name = guest.shipping_first_name;
      orderData.shipping_last_name = guest.shipping_last_name;
      orderData.shipping_street_1 = guest.shipping_street_1;
      orderData.shipping_street_2 = guest.shipping_street_2;
      orderData.shipping_city = guest.shipping_city;
      orderData.shipping_state = guest.shipping_state;
      orderData.shipping_zip = guest.shipping_zip;
      orderData.shipping_phone = guest.shipping_phone;
      orderData.alternate_shipping_phone = guest.alternate_shipping_phone;
      orderData.billing_same_as_shipping = guest.billing_same_as_shipping;
      orderData.billing_company_name = guest.billing_company_name;
      orderData.billing_first_name = guest.billing_first_name;
      orderData.billing_last_name = guest.billing_last_name;
      orderData.billing_street_1 = guest.billing_street_1;
      orderData.billing_street_2 = guest.billing_street_2;
      orderData.billing_city = guest.billing_city;
      orderData.billing_state = guest.billing_state;
      orderData.billing_zip = guest.billing_zip;
      orderData.billing_phone = guest.billing_phone;
      orderData.alt_billing_phone = guest.alt_billing_phone;
      orderData.comments = guest.comments;
      orderData.side_mark = guest.side_mark;
      orderData.create_account = guest.create_account;
      orderData.password_1 = guest.password_1;
      orderData.password_2 = guest.password_2;
      orderData.mail_list = guest.mail_list;
    }

    // For non-guest checkout, these come from expressCheckoutData directly
    if (!expressCheckoutData.guest_checkout) {
      orderData.comments = expressCheckoutData.comments;
      orderData.side_mark = expressCheckoutData.side_mark;
    }
    orderData.screen_width = screen.width;
    orderData.screen_height = screen.height;
    let clientSecret = '';
    let orderCode = '';
    const paymentIntentResponse = await stripePaymentIntentAction(orderData);

    //console.log('ExpressCheckoutElement', 'onConfirm', 'paymentIntentResponse', paymentIntentResponse)

    if (paymentIntentResponse.client_secret && paymentIntentResponse.order_code) {
      clientSecret = paymentIntentResponse.client_secret;
      orderCode = paymentIntentResponse.order_code;
      confirmStripePayment(clientSecret, orderCode);
    } else {
      trackWallet('WALLET:INTENT_FAILED', {
        wallet: event_0.expressPaymentType,
        order_total: expressCheckoutData.orderTotal,
        response_message: paymentIntentResponse?.message
      });
      setErrorMessage('We were unable to process your payment. Please try again or contact us at orderdesk@hivemodern.com.');
    }
  };
  const confirmStripePayment = async (clientSecret_0, orderCode_0) => {
    setErrorMessage('');

    // Return to the completion endpoint, which verifies the charge with
    // Stripe, completes the order, empties the cart, and redirects to the
    // read-only receipt. Stripe appends payment_intent + redirect_status.
    // URL-encode the order code in case it contains special characters (legacy bcrypt hashes have $)
    let return_url = `${process.env.NEXT_PUBLIC_SITE_URL}/api/checkout/complete?order_code=${encodeURIComponent(orderCode_0)}`;
    const stripeResponse = await stripe.confirmPayment({
      elements,
      clientSecret: clientSecret_0,
      confirmParams: {
        // Return URL where the customer should be redirected after the PaymentIntent is confirmed.
        return_url: return_url
      }
    });

    // confirmPayment only resolves here when the payment did not go
    // through - success navigates to the return_url. Show the customer
    // the decline reason from Stripe.
    if (stripeResponse?.error) {
      trackWallet('WALLET:CONFIRM_FAILED', {
        code: stripeResponse.error.code,
        decline_code: stripeResponse.error.decline_code,
        type: stripeResponse.error.type,
        message: stripeResponse.error.message
      });
      setErrorMessage(stripeResponse.error.message || 'Your payment could not be processed. Please try again or contact us at orderdesk@hivemodern.com.');
    }
  };
  return <>
            {isVisible && <>
                    <ExpressCheckoutElement options={expressCheckoutOptions} onReady={onReady} onClick={onClick} onCancel={onCancel} onShippingAddressChange={onShippingAddressChange} onConfirm={onConfirm} />
                    {errorMessage && <div className="text-red text-sm mt-3" role="alert">
                            {errorMessage}
                        </div>}
                    <div className="flex items-center justify-center gap-2 lg:gap-3 xl:gap-4 mt-3">
                        {displayStandardPaymentIcons && <>
                                <Image src="/images/payment-logo-color-visa.png" width={38} height={24} quality={90} sizes="38px" alt="Visa" />
                                <Image src="/images/payment-logo-color-mastercard.png" width={38} height={24} quality={90} sizes="38px" alt="Mastercard" />
                                <Image src="/images/payment-logo-color-american-express.png" width={38} height={24} quality={90} sizes="38px" alt="American Express" />
                                <Image src="/images/payment-logo-color-discover.png" width={38} height={24} quality={90} sizes="38px" alt="Discover" />
                            </>}
                        {displayExpressPaymentIcons && <>
                                {visiblePaymentMethods.applePay && <Image className="" src="/images/payment-logo-color-apple.png" width={38} height={24} quality={90} sizes="38px" alt="Apple Pay" />}
                                {visiblePaymentMethods.googlePay && <Image className="" src="/images/payment-logo-color-google.png" width={38} height={24} quality={90} sizes="38px" alt="Google Pay" />}
                                {visiblePaymentMethods.paypal && <Image className="" src="/images/payment-logo-color-paypal.png" width={38} height={24} quality={90} sizes="38px" alt="Paypal" />}
                            </>}
                    </div>
                </>}
        </>;
};
export default function StripeCheckoutElement(t0) {
  const $ = _c(20);
  const {
    expressCheckoutData,
    displayExpressPaymentIcons,
    displayStandardPaymentIcons,
    className
  } = t0;
  const [stripePromise, setStripePromise] = useState(null);
  let t1;
  let t2;
  if ($[0] !== stripePromise) {
    t1 = () => {
      if (!stripePromise) {
        setStripePromise(loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY));
      }
    };
    t2 = [stripePromise];
    $[0] = stripePromise;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      theme: "stripe",
      variables: {
        borderRadius: "3px"
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const stripeAppearance = t3;
  let t4;
  if ($[4] !== expressCheckoutData.orderTotal) {
    t4 = formatStripeAmount(expressCheckoutData.orderTotal);
    $[4] = expressCheckoutData.orderTotal;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = {
      locale: "en",
      mode: "payment",
      amount: t4,
      currency: "usd",
      appearance: stripeAppearance
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const stripeOptions = t5;
  if (!stripePromise) {
    return null;
  }
  const t6 = `${className}`;
  let t7;
  if ($[8] !== displayExpressPaymentIcons || $[9] !== displayStandardPaymentIcons || $[10] !== expressCheckoutData) {
    t7 = <StripeExpressCheckoutElement expressCheckoutData={expressCheckoutData} displayExpressPaymentIcons={displayExpressPaymentIcons} displayStandardPaymentIcons={displayStandardPaymentIcons} />;
    $[8] = displayExpressPaymentIcons;
    $[9] = displayStandardPaymentIcons;
    $[10] = expressCheckoutData;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== expressCheckoutData.orderTotal || $[13] !== stripeOptions || $[14] !== stripePromise || $[15] !== t7) {
    t8 = <Elements key={expressCheckoutData.orderTotal} stripe={stripePromise} options={stripeOptions}>{t7}</Elements>;
    $[12] = expressCheckoutData.orderTotal;
    $[13] = stripeOptions;
    $[14] = stripePromise;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className={t6}>{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}